const UNREVIEWED_COUNT_API = "/perfect-shot/unreviewed-count";

export class PerfectShotMonitor {
    constructor() {
        this.init();
    }

    init() {
        document.body.addEventListener("five-minute-mark", () => this.check());
        // PerfectShotCases.js broadcasts its own count after a Review click / its poll;
        // it never touches the badge itself.
        document.body.addEventListener("perfect-shot-unreviewed-changed", (event) => {
            const count = event && event.detail ? event.detail.count : null;
            if (typeof count === "number") {
                this.updateBadge(count);
            }
        });
        this.check();
    }

    // Gate check without a round-trip: no sidebar entry => PS not visible for this
    // user, so skip the fetch entirely rather than collecting 403s on every page.
    sidebarLink() {
        const menuSidebar = document.querySelector("menu-sidebar");
        return menuSidebar
            ? menuSidebar.querySelector("a[href='/perfect-shot/cases']")
            : null;
    }

    check() {
        if (!this.sidebarLink()) {
            return;
        }
        fetch(UNREVIEWED_COUNT_API, { headers: { Accept: "application/json" } })
            .then(response => (response.ok ? response.json() : null))
            .then(data => {
                if (data && data.success) {
                    this.updateBadge(data.count || 0);
                }
            })
            .catch(error => {
                console.error("Error fetching Perfect Shot unreviewed count:", error);
            });
    }

    updateBadge(count) {
        let badge = document.querySelector("#perfect-shot-unreviewed-count-badge");
        if (!badge) {
            badge = this.createBadge();
        }
        if (!badge) {
            return; // sidebar not present (public pages) or PS not visible
        }
        const link = badge.querySelector("a");
        if (link) {
            link.textContent = count;
        }
        // AC: badge is removed entirely at 0, never rendered as "0"
        badge.style.display = count > 0 ? "flex" : "none";
    }

    createBadge() {
        const psLink = this.sidebarLink();
        if (!psLink) {
            return null;
        }

        const badge = document.createElement("div");
        badge.id = "perfect-shot-unreviewed-count-badge";
        const popOver = document.createElement("pop-over");
        popOver.textContent = "Cases with unreviewed Perfect Shot issues";
        const link = document.createElement("a");
        link.href = "javascript:void(0)";
        badge.appendChild(popOver);
        badge.appendChild(link);
        badge.style.display = "none";
        psLink.appendChild(badge);

        badge.addEventListener("click", () => {
            window.location.href = "/perfect-shot/cases";
        });
        return badge;
    }
}

// guard against the module loading after DOMContentLoaded has already fired
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => new PerfectShotMonitor());
} else {
    new PerfectShotMonitor();
}
